import React, { useMemo } from "react";
import Select from "react-select";
import { COLORS } from "../constants/colors";

const MultiSelectDropdownKpiType = ({
  selectedItems = [],
  onChange,
  placeholder = "Select options",
  kpiTypeOption,
}) => {

  const normalizedOptions = useMemo(() => {
    return Object.keys(kpiTypeOption || {}).map((key) => ({
      id: key,
      name: kpiTypeOption[key]?.value ?? key,
      count: kpiTypeOption[key]?.count ?? 0,
    }));
  }, [kpiTypeOption]);

  const selectOptions = useMemo(() => {
    return normalizedOptions.map((opt) => ({
      label: opt.name,
      value: opt,
    }));
  }, [normalizedOptions]);

  const selectValue = useMemo(() => {
    return selectedItems.map((item) => ({
      label: item.name,
      value: item,
    }));
  }, [selectedItems]);

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: 42,
      borderRadius: 8,
      fontSize: 14,
      borderColor: "#D1D5DB",
      boxShadow: "none",
      ":hover": { borderColor: "#9CA3AF" },
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: COLORS.PRIMARY_LIGHT,
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: COLORS.PRIMARY,
      fontWeight: 500,
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: COLORS.PRIMARY,
      ":hover": { opacity: 0.7, backgroundColor: "transparent" },
    }),
  };

  return (
    <Select
      isMulti
      options={selectOptions}
      value={selectValue}
      placeholder={placeholder}
      styles={selectStyles}
      closeMenuOnSelect={false}
      onChange={(items) => {
        onChange(items.map((i) => i.value));
      }}
    />
  );
};

export default MultiSelectDropdownKpiType;
